export const API_ERROR_NAME = 'ApiError';
export const API_ERROR_DEFAULT_MESSAGE = 'Неизвестная ошибка';
export const API_ERROR_DEFAULT_CODE = 'UNKNOWN CODE';
